import { Action } from '@ngrx/store';
import {TrialLicensesMgt, TrialLicensesMgtParams} from '../license-mgt.model';

export enum TrialLicenseActionTypes {
  LoadTrialLicenses = '[TrialLicense] Load TrialLicenses',
  GetTrialLicenses = '[TrialLicense] Get TrialLicenses',
  GetTrialLicensesFail = '[TrialLicense] Get TrialLicenses Fail',
  AddTrialLicenses = '[TrialLicense] Add TrialLicenses',
  DeleteTrialLicenses = '[TrialLicense] Delete TrialLicenses',
  UpdateTrialLicenses = '[TrialLicense] Update TrialLicenses',
}

export class LoadTrialLicenses implements Action {
  readonly type = TrialLicenseActionTypes.LoadTrialLicenses;
  constructor(public payload: TrialLicensesMgt[]) {}
}

export class GetTrialLicenses implements Action {
  readonly type = TrialLicenseActionTypes.GetTrialLicenses;
}

export class AddTrialLicenses implements Action {
  readonly type = TrialLicenseActionTypes.AddTrialLicenses;
  constructor(public payload: TrialLicensesMgtParams) {}
}

export class DeleteTrialLicenses implements Action {
  readonly type = TrialLicenseActionTypes.DeleteTrialLicenses;
  constructor(public payload: number) {}
}

export class UpdateTrialLicenses implements Action {
  readonly type = TrialLicenseActionTypes.UpdateTrialLicenses;
  constructor(public payload: TrialLicensesMgtParams) {}
}

export class GetTrialLicensesFail implements Action {
  readonly type = TrialLicenseActionTypes.GetTrialLicensesFail;
}


export type TrialLicenseActions = LoadTrialLicenses
  | GetTrialLicenses
  | AddTrialLicenses
  | DeleteTrialLicenses
  | UpdateTrialLicenses
  | GetTrialLicensesFail;
